import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, showToast } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("admin_token")) {
      api.get("/admin/me").then(()=>navigate("/admin/dashboard")).catch(()=>{
        localStorage.removeItem("admin_token");
      });
    }
  }, [navigate]);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true); setErr("");
    try {
      const r = await api.post("/admin/login", { username: u, password: p });
      if (r.data.admin_token) localStorage.setItem("admin_token", r.data.admin_token);
      showToast("Welcome back, " + r.data.admin.name);
      navigate("/admin/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="alog-wrap">
      <div className="alog-box">
        <div className="alog-logo"><strong style={{fontFamily:"'Outfit',sans-serif",fontStyle:"normal"}}>LANTEN</strong> <span style={{fontStyle:"italic"}}>forum</span></div>
        <div className="alog-title">Moderator Panel</div>
        <div className="alog-sub">Restricted access. All moderation actions are logged and audited.</div>
        <form onSubmit={submit}>
          <div className="aff"><label>Username</label>
            <input data-testid="admin-username" value={u} onChange={(e)=>setU(e.target.value)} placeholder="Enter username" autoComplete="username" />
          </div>
          <div className="aff"><label>Password</label>
            <input data-testid="admin-password" type="password" value={p} onChange={(e)=>setP(e.target.value)} placeholder="Enter password" autoComplete="current-password" />
          </div>
          {err && <div className="aerr" data-testid="admin-error">{err}</div>}
          <button type="submit" data-testid="admin-login-btn" className="alog-btn" disabled={busy}>{busy ? "Signing in…" : "Access Panel →"}</button>
        </form>
        <div style={{textAlign:"center",marginTop:14}}>
          <span style={{fontSize:13,color:"#5A6280",cursor:"pointer"}} onClick={()=>window.location.href="/"}>← Back to Forum</span>
        </div>
      </div>
    </div>
  );
}
